import { useEffect, useState } from 'react';
import { apiFetch } from '../api';

/**
 * Whether this environment takes phone calls: `voice_channel_enabled` in terraform, read by
 * the backend (services/phone.py) and answered by `GET /api/phone/status`.
 *
 *   const phoneOn = usePhoneCalls();     // null until known, then true or false
 *   const phone = usePhoneStatus();      // null until known, then the whole answer:
 *                                        // { enabled, webhook_url, stream_url }
 *
 * Every phone setting (Tiers' Phone calls tab, the Account tab's phone switch, the Channels
 * page's Phone card, the Voice page's realtime provider, the Tools page's Phone calls card)
 * shows only on `true`. Asked once per session and shared by every page. A failed ask reads
 * as on, as GATED_PAGES does in App.jsx: a setting then shows where it may do nothing,
 * rather than hide where it is needed; the server refuses a phone line all the same. The two
 * addresses are where Twilio reaches voice-bridge, "" when the backend does not know them.
 */
let known = null;
let asking = null;

const NO_ADDRESSES = { webhook_url: '', stream_url: '' };

function ask() {
  if (!asking) {
    asking = apiFetch('/api/phone/status')
      .then(r => (r.ok ? r.json() : { enabled: true }))
      .then(body => ({ ...NO_ADDRESSES, ...body, enabled: body.enabled !== false }))
      .catch(() => ({ ...NO_ADDRESSES, enabled: true }))
      .then(status => { known = status; return status; });
  }
  return asking;
}

export function usePhoneStatus() {
  const [status, setStatus] = useState(known);
  useEffect(() => {
    if (known !== null) return undefined;
    let alive = true;
    ask().then(value => { if (alive) setStatus(value); });
    return () => { alive = false; };
  }, []);
  return status;
}

export default function usePhoneCalls() {
  const status = usePhoneStatus();
  return status === null ? null : status.enabled;
}
